export default {
  subscription: 'hopbomb',
  mailing_list: 18,
  info_url: 'http://monthly.tavour.com/signup/',
  title: {
    in_progress: 'Start your Hop Bomb Subscription ',
    success: 'Congrats! You are Confirmed for a Hop Bomb Subscription',
    subtext: '8 world class, fresh IPAs delivered to your door every month.',
  },
  cancel_anytime: 'Once we email you about a month\'s selection, you\'ll always have at least 48 hours to let us know via ' +
  'email if you want to skip the beers. If needed, we\'ll cancel your subscription and confirm with a ' +
  'simple email. Real, beer loving people answer every email: please get in touch if you have any ' +
  'requests or questions.',
  review: {
    agreement: 'I agree to the <a href="https://www.tavour.com/terms-of-use" target="_blank">terms of service</a> and automatic billing. ',
    summary: [
      'Hop Bomb Subscription',
      '8 world class, fresh IPAs for just $75',
      'Shipped & Billed 15th of every month',
      'Skip months for free, cancel anytime',
    ],
    button_text: 'Send me the IPAs!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/hopbomb.js